<template>
  <div class="iasi">
    <h1>Comunismul, Kommunismus</h1>
      <article>
        Doriţi o prelungare? Faceţi un click pe o posa!
        Posele marcat cu "nn" nu sânt de la mine.<br/>
          Klicken Sie auf ein Foto, 
          um eine Vergrößerung zu erhalten<br>
          Mit (nn) markierte Fotos stammen nicht von mir.
      </article>
      <article class="fotos">
        <div class="foto">
            <img src="../assets/fotos/resc_6kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Denkmal der Deportation der Banater Berglanddeutschen nach Rußland 1945"
            @click="callImageClick('Reschitza, Reşiţa: Denkmal der Deportation der Banater Berglanddeutschen nach Rußland 1945', 'resc_6.jpg', $event)">
            <br>Reschitza, Reşiţa: Denkmal der Deportation der Banater Berglanddeutschen nach Rußland 1945
        </div>
        <div class="foto">
            <img src="../assets/fotos/orav_3kl.jpg" width="125" border="0" height="110" alt="Bahnhof Oraviţa / Oravitza: 
            Erinnerung an die Deportation aus dem Banat ins Baragan am schwarzen Pfingsten 1951"
            @click="callImageClick('Bahnhof Oraviţa / Oravitza:  Erinnerung an die Deportation aus dem Banat ins Baragan am schwarzen Pfingsten 1951', 
            'orav_3.jpg', $event)">
                    <br>Bahnhof Oraviţa / Oravitza: Erinnerung an die Deportation aus dem Banat ins Baragan am schwarzen Pfingsten 1951
            <br>Im Jahre 1951 wurden viele Banater entlang der Grenze zu Serbien  
            in die Steppe des Baragan deportiert. Für die Deutschen im Banat war 
            dies die zweite verlustreiche Deportation innerhalb weniger Jahre.
        </div>
        <div class="foto">
            <img src="../assets/fotos/antikommunistischer_Widerstand_kl.jpg" width="125" border="0" height="110" alt="resistenţa anticomunista, antikommunistischer Widerstand"
            @click="callImageClick('resistenţa anticomunista, antikommunistischer Widerstand', 'antikommunistischer_Widerstand.jpg', $event)">
            <br>resistenţa anticomunista, antikommunistischer Widerstand
        </div>
        <div class="foto">
            <img src="../assets/fotos/Kleidung_mit_Einschussloechern_kl.jpg" width="125" border="0" height="110" alt="Kleidung eines antikommunistischen Partisanen"
            @click="callImageClick('Kleidung eines antikommunistischen Partisanen', 'Kleidung_mit_Einschussloechern.jpg', $event)">
            <br>Kleidung eines antikommunistischen Partisanen
        </div>
        <div class="foto">
            <img src="../assets/fotos/Sighet_Dunkelzelle_1kl.jpg" width="125" border="0" height="110" alt="Dunkelzelle in Sighet"
            @click="callImageClick('Dunkelzelle in Sighet', 'Sighet_Dunkelzelle_1.jpg', $event)">
            <br>Dunkelzelle in Sighet
        </div>
        <div class="foto">
            <img src="../assets/fotos/Sighet_Dunkelzelle_2kl.jpg" width="125" border="0" height="110" alt="Dunkelzelle in Sighet"
            @click="callImageClick('Dunkelzelle in Sighet', 'Sighet_Dunkelzelle_2.jpg', $event)">
            <br>Dunkelzelle in Sighet
        </div>
        <div class="foto">
            <img src="../assets/fotos/ceau_1kl.jpg" width="125" border="0" height="110" alt="Propaganda und Personenkult"
            @click="callImageClick('Propaganda und Personenkult', 'ceau_1.jpg', $event)">
            <br>Propaganda und Personenkult
        </div>
        <div class="foto">
            <img src="../assets/fotos/ceau_2kl.jpg" width="125" border="0" height="110" alt="Propaganda und Personenkult"
            @click="callImageClick('Propaganda und Personenkult', 'ceau_2.jpg', $event)">
            <br>Propaganda und Personenkult: Ceaușescu "der Sohne des Volkes und der Gerechtigkeit inmitten der Söhne des Landes"
        </div>
      </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>